import { nullableString } from 'shared-code/conversion'
import { DSDealBar } from 'shared-definitions/types'
import { ApiDealBarLink } from 'data-source/types.wp'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { pLinkExternalMapper, PLinkMapperOpts } from './pLinkMapper'

export function dealBarMapper(input: ApiDealBarLink, opts: PLinkMapperOpts): DSDealBar {
  return {
    color: nullableString(input.color),
    icon: input.icon ? imageMapper(input.icon, opts) : null,
    label: input.text,
    pLink: pLinkExternalMapper(input.url),
    sticky: input.sticky,
  }
}
